export type SupportedLanguage = 'sr' | 'en';
export const SUPPORTED_LANGUAGES: SupportedLanguage[] = ['sr', 'en'];
export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';
export const LANGUAGE_STORAGE_KEY = 'app_language';

export interface IPublicTranslation {
  key: string;
  values: Record<string, string>;
}
